const initHomepage = function () {
  const tiles = document.querySelectorAll(".home-tiles .tile");
  const newsletterModal = document.querySelector(".modal.newsletter");

  window.setTimeout(() => {
    document.body.classList.add("modal-active");
    newsletterModal.classList.add("active");
  }, 1000);

  if (window.IS_TOUCH) {
    tiles.forEach((tile) => {
      tile.addEventListener("mouseover", (e) => {
        e.preventDefault();
      });
      tile.addEventListener("click", (e) => {
        if (tile.classList.contains("hover")) {
          return true;
        } else {
          e.preventDefault();
          tile.classList.add("hover");
          window.setTimeout(function () {
            tile.classList.remove("hover");
          }, 2000);
        }
      });
    });
  }
};

export { initHomepage };
